import { UIActionType, UIAction } from '../../actions/uiActions';

const feedbackDialogReducer = (state = false, action: UIAction) => {
  switch (action.type) {
    case UIActionType.TOGGLE_FEEDBACK_DIALOG:
      return !state;
    default:
      return state;
  }
};

export default feedbackDialogReducer;
